import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'

/***
 *
 * 获取旅行管理列表 get
 * @param query 分页参数
 * @return request
 * */
export function getTravelList(query) {
  return request({
    url: `${baseURL.businessApi}/travels`,
    method: 'get',
    params: query
  })
}

/**
 * 增加旅行管理 post
 * @param data 增加的数据
 * @return request
 * */
export function addTravel(data) {
  return request({
    url: `${baseURL.businessApi}/travels`,
    method: 'post',
    data: data
  })
}

/**
 * 删除旅行管理  delete
 * @param id 旅行管理id
 * @return request
 * */
export function deleteTravel(id) {
  return request({
    url: `${baseURL.businessApi}/travels/${id}`,
    method: 'delete'
  })
}

/***
 * 修改旅行管理 Post
 * @param id 要修改的旅行管理id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateTravel(id, data) {
  return request({
    url: `${baseURL.businessApi}/travels/${id}`,
    method: 'post',
    data: data
  })
}


/**
 * 通过id查看旅行详情
 * @param id
 * @returns {AxiosPromise}
 */
export function getTravelsById(id) {
  return request({
    url: `${baseURL.businessApi}/travels/${id}`,
    method: 'get'
  })
}


/**
 * 根据区域选择球场(后台)
 * @param id
 * @returns {AxiosPromise}
 */
export function getByAreaId(areaId) {
  return request({
    url: `${baseURL.businessApi}/courts/byAreaId?areaId=${areaId}`,
    method: 'get'
  })
}

/**
 * 查询旅行ID名称
 * @returns {AxiosPromise}
 */
export function getTravelsName() {
  return request({
    url: `${baseURL.businessApi}/travels/getTravelsName`,
    method: 'get'
  })
}
